import React from 'react'
import { Button } from '@material-ui/core'

const DefaultReservationButton = (props) => (
    <Button
        onClick={props.onClick}
        disableElevation
        variant="contained"
        color="primary"
        disabled={!!props.isDisabled}
        ref={props.buttonRef}
    >
        {props.label}
    </Button>
)

export default DefaultReservationButton
